import { useMemo } from "react";
import { SectionLink } from "~/utils/markdownTerms";
import { useDocList } from "./useDocList";

export const useSectionLinks = (): SectionLink[] => {
  const { docList, firstPageIds } = useDocList();

  const sectionLinks = useMemo<SectionLink[]>(() => {
    if (!docList?.tree) return [];

    return docList.tree.flatMap((category) =>
      category.sections
        .filter((section) => section.name?.trim() && firstPageIds[section.id])
        .map((section) => ({
          sectionId: section.id,
          sectionName: section.name,
          firstPageId: firstPageIds[section.id],
        }))
    );
  }, [docList, firstPageIds]);

  return sectionLinks;
};
